module.exports = __webpack_public_path__ + "static/media/badger.b44cc577.png";